<template>
	<div>
		<tabs-component :tabs="tabs"></tabs-component>
		<router-view></router-view>
	</div>
</template>

<script>

import TabsComponent from '@/components/shared/TabsComponent';

function data() {
	return {
		tabs: [
			{
				id: 1,
				title: 'Por Solucionar',
				link: { name: 'unresolved' },
			},
			{
				id: 2,
				title: 'Solucionados',
				link: { name: 'solved' },
			},
		],
	};
}

export default {
	name: 'problem-container',
	components: {
		TabsComponent,
	},
	data,
};
</script>



// WEBPACK FOOTER //
// ProblemReport.vue?81b19370